import { showDialogOverlay, hideDialogOverlay } from "../../../utils/dialogOverlay.js";

const API = "/api";
let didBind = false;

function ensureKisilerOverviewDialog() {
	if (document.getElementById("kisilerOverviewDialog")) return;
	document.body.insertAdjacentHTML("beforeend", `
<dialog id="kisilerOverviewDialog">
    <div class="kisiler-overview-container">
        <div class="kisiler-overview-header">
            <div class="kisiler-overview-header-text">
                <h2 class="kisiler-overview-title"></h2>
                <span class="kisiler-overview-tc"></span>
            </div>
            <button class="kisiler-overview-close">&#10005;</button>
        </div>
        <div class="kisiler-overview-body">
            <div class="overview-section">
                <div class="overview-section-header">Ki\u015fi Bilgileri</div>
                <div class="overview-section-body kisiler-overview-grid"></div>
            </div>
        </div>
        <div class="overview-footer">
            <button class="kisiler-overview-close-btn">Kapat</button>
        </div>
    </div>
</dialog>`);
}

export function initKisilerOverviewDialog() {
	ensureKisilerOverviewDialog();
	const dialog = document.querySelector("#kisilerOverviewDialog");
	if (!dialog || didBind) return;
	didBind = true;

	window.openKisilerOverviewDialog = async (tc) => {
		clearDialog(dialog);
		dialog.showModal();
		showDialogOverlay(dialog, "Y\u00fckleniyor...");
		await new Promise((r) => setTimeout(r, 350));
		try {
			const res = await fetch(`${API}/kisiler/${encodeURIComponent(tc)}`);
			if (!res.ok) throw new Error(`HTTP ${res.status}`);
			const data = await res.json();
			fillDialog(dialog, data);
		} catch (err) {
			console.error("Kisi overview yuklenemedi:", err);
		} finally {
			hideDialogOverlay();
		}
	};

	document.body.addEventListener("click", (e) => {
		if (e.target.closest(".kisiler-overview-close") || e.target.closest(".kisiler-overview-close-btn")) {
			dialog.close();
		}
	});
}

const OVERVIEW_FIELDS = [
	"T.C. Kimlik No",
	"Ad",
	"Soyad",
	"Departman",
	"\u00dcnvan",
	"Durum",
	"Olu\u015fturma Tarihi",
];

function clearDialog(dialog) {
	dialog.querySelector(".kisiler-overview-title").textContent = "\u2014";
	dialog.querySelector(".kisiler-overview-tc").textContent = "\u2014";
	dialog.querySelector(".kisiler-overview-grid").innerHTML = OVERVIEW_FIELDS.map(
		(label) => `<div class="overview-detail">
                    <span class="overview-detail-label">${label}</span>
                    <span class="overview-detail-value">\u2014</span>
                </div>`,
	).join("");
}

function fillDialog(dialog, d) {
	dialog.querySelector(".kisiler-overview-title").textContent = `${d.first_name ?? ""} ${d.last_name ?? ""}`.trim() || "\u2014";
	dialog.querySelector(".kisiler-overview-tc").textContent = d.tc ?? "";
	dialog.querySelector(".kisiler-overview-title").title = dialog.querySelector(".kisiler-overview-title").textContent;
	dialog.querySelector(".kisiler-overview-tc").title = dialog.querySelector(".kisiler-overview-tc").textContent;

	const grid = dialog.querySelector(".kisiler-overview-grid");
	const tarih = d.olusturma_tarihi
		? new Date(d.olusturma_tarihi).toLocaleDateString("tr-TR", { day: "2-digit", month: "2-digit", year: "numeric" })
		: "\u2014";
	const rows = [d.tc, d.first_name, d.last_name, d.departman_adi, d.unvan, d.is_active ? "Aktif" : "Pasif", tarih];
	[...grid.querySelectorAll(".overview-detail-value")].forEach((el, i) => {
		el.textContent = rows[i] ?? "\u2014";
		el.title = el.textContent;
	});
}
